import { store_type } from '../../common/models/constant'

export function buildCatalog(store: S3Types.store): S3Types.catalog {
  const catalog: S3Types.catalog = {}
  if (store?.setting?.settings?.general?.type === store_type.MINISTORE) {
    store.pages &&
      Object.entries(store.pages)?.forEach(([subpath, page]) => {
        if (!page?.setting?.settings?.configurations?.show_inhomepage) return
        const sellpagePrices = sellpagePrice(page)
        const soldout = Object.entries(page.setting?.variants?.items ?? {}).every(
          ([, item]) => item.sellable === false
        )
        catalog[subpath] = {
          title: page.setting?.settings?.general?.title,
          review_score: getAvarageRated(page.reviews ?? []),
          price: sellpagePrices?.default_price ?? 0,
          compare_price: sellpagePrices?.compare_price ?? 0,
          logo: page.setting?.gallery?.[0] ?? '',
          soldout
        }
      })
  }

  return catalog
}

export function injectSellable(pageSetting?: S3Types.page_setting) {
  if (pageSetting?.variants?.items) {
    Object.keys(pageSetting.variants.items).map((page_variant_id) => {
      const variantItem = pageSetting.variants.items[page_variant_id]
      const productBaseSellable = !(
        process._repository.pbases?.[variantItem.pbase_id ?? '']?.variants?.items?.[
          variantItem.pbase_variant_id ?? ''
        ]?.sellable === false
      )

      const productPageSellable = !(
        process._repository.ppages?.[pageSetting?.settings?.general?.ppage_id ?? 'a']?.setting
          ?.variants?.items?.[variantItem?.ppage_variant_id ?? 'a']?.sellable === false
      )

      pageSetting.variants.items[page_variant_id].sellable =
        productBaseSellable && productPageSellable
    })
  }
}

export function injectSoldoutSellpage(store?: S3Types.store) {
  const repoStore = process._repository.stores?.[store?.setting?.settings?.general?.id ?? '']
  if (repoStore && store?.catalog) {
    Object.keys(store.catalog).forEach((page_slug) => {
      if (store && store.catalog) {
        const page = repoStore?.pages?.[page_slug]
        injectSellable(page?.setting)
        if (!page) store.catalog[page_slug] = { ...store.catalog[page_slug], soldout: true }
        else {
          const soldout = Object.entries(page.setting?.variants?.items ?? {}).every(
            ([, item]) => item.sellable === false
          )
          store.catalog[page_slug] = { ...store.catalog[page_slug], soldout }
        }
      }
    })
  }
}

/**
 * Remove properties which all related variant items are unsellable
 * @param variants
 */
export function removeUnavailableProperties(variants?: S3Types.page_variants) {
  if (variants && variants.items && variants.properties) {
    const sellableItems = Object.fromEntries(
      Object.entries(variants.items).filter((item) => item[1].sellable)
    )
    const availableProperties = Object.values(sellableItems).reduce((total, item) => {
      Object.entries(item.properties).forEach(([key, value]) => {
        if (!total[key]) total[key] = []
        if (!total[key].includes(value)) total[key].push(value)
      })
      return total
    }, {} as { [key: string]: string[] })
    const newProps = Object.entries(variants.properties).reduce((total, [key, prop]) => {
      const values = Object.fromEntries(
        Object.entries(prop.values ?? {}).filter(([itemKey]) => {
          return availableProperties[key] && availableProperties[key].includes(itemKey)
        })
      )
      if (!isEmpty(values)) total[key] = { ...prop, values }
      return total
    }, {} as S3Types.page_variants_properties)
    variants.properties = newProps
  }
}

function initProperties(properties: S3Types.page_variants_properties) {
  const init: S3Types.item_properties = {}
  Object.keys(properties).forEach((key) => {
    init[key] = Object.entries(properties[key]?.values ?? {})?.[0]?.[1]?.code ?? ''
  })
  return init
}

function compareProperties(props1: S3Types.item_properties, props2: S3Types.item_properties) {
  let isEqual = true

  Object.keys(props1).forEach((key) => {
    if (props1[key] !== props2[key]) {
      isEqual = false
    }
  })

  return isEqual
}

function findVariant(
  properties: S3Types.item_properties,
  variantItems: S3Types.page_variants_items
) {
  const variantIds = Object.keys(variantItems)
  const foundVariantId = variantIds.find((variantId) =>
    compareProperties(properties, variantItems[variantId].properties ?? {})
  )
  return foundVariantId ? variantItems[foundVariantId] : undefined
}

function sellpagePrice(page: S3Types.page) {
  if (page) {
    const variants = page.setting?.variants
    if (variants) {
      // const defaultId = variants?.default_variant_id ?? ''
      // const item = variants.items?.[defaultId] ?? Object.values(variants.items)?.[0]
      const initProperty = initProperties(variants?.properties ?? {})
      const item = findVariant(initProperty, variants.items)
      return item
    }
  }
}

function getAvarageRated(reviews: S3Types.page_review[]) {
  if (reviews.length) {
    const totalRated = reviews.reduce((total, review) => total + (review.rating ?? 0), 0)
    return Math.ceil(totalRated / reviews.length)
  }

  return 0
}

function isEmpty(obj: any) {
  return JSON.stringify(obj) === '{}'
}
